module.exports = __webpack_public_path__ + "static/img/point-bg1.b94bf6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/point-bg1.png
// module id = 5AzG
// module chunks = 0